import * as React from 'react';

const Footer: React.SFC = () => (
  <footer className="wtc-footer">
    <ul className="wtc-footer__left-side-content">
      <li />
    </ul>
    <ul className="wtc-footer__right-side-content">
      <li>
        <a href="http://github.com/ruden91" target="_blank">
          Who made this?
        </a>
      </li>
    </ul>
  </footer>
);

export default Footer;



// WEBPACK FOOTER //
// ./src/components/Footer.tsx